import ConstantsServices from "../services/ConstantsServices";
import { Country } from "../services/ConstantsServices.dto";

export const getCountriesList = async (
  countriesData: Country[],
  setLoading: Function = () => {}
) => {
  if (countriesData && countriesData.length > 0) {
    return countriesData;
  }

  const countries = await ConstantsServices.getCountries({ setLoading });
  return countries;
};

export const filterCountries = (
  input: string,
  countries: Country[]
): { [key: string]: string }[] => {
  const filteredCountries = countries.filter((country) =>
    country.label
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .includes(
        input
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      )
  );
  return filteredCountries as unknown as { [key: string]: string }[];
};
